import { Dialog as DialogComponent } from '@syncfusion/ej2-popups';
import { extend, remove, isNullOrUndefined } from '@syncfusion/ej2-base';
import { focus, locale } from '../common/index';
/**
 * Dialog Service.
 *
 * @hidden
 */
export class Dialog {
    /**
     * Constructor for initializing dialog service.
     *
     * @param {Spreadsheet} parent - Specifies the Spreadsheet instance.
     */
    constructor(parent) {
        this.parent = parent;
    }
    /**
     * To show dialog.
     *
     * @param {DialogModel} dialogModel - Specifies the Dialog model.
     * @param {boolean} cancelBtn - Specifies the cancel button.
     * @returns {void}
     */
    show(dialogModel, cancelBtn) {
        let btnContent;
        cancelBtn = isNullOrUndefined(cancelBtn) ? true : false;
        const beforeOpenHandler = dialogModel.beforeOpen || null;
        const closeHandler = dialogModel.close || null;
        const model = {
            header: 'Spreadsheet',
            cssClass: this.parent.cssClass,
            target: this.parent.element,
            buttons: [],
            allowDragging: true
        };
        dialogModel.beforeOpen = (args) => {
            if (beforeOpenHandler) {
                beforeOpenHandler(args);
                if (args.cancel) {
                    this.hide(true);
                    if (!args.preventFocus) {
                        focus(this.parent.element);
                    }
                }
            }
        };
        dialogModel.close = () => {
            this.destroyDialog();
            if (closeHandler) {
                closeHandler();
            }
        };
        extend(model, dialogModel);
        if (cancelBtn) {
            btnContent = this.parent.serviceLocator.getService(locale).getConstant(model.buttons.length ? 'Cancel' : 'Ok');
            model.buttons.push({
                buttonModel: { content: btnContent, isPrimary: model.buttons.length === 0 },
                click: this.hide.bind(this)
            });
        }
        const div = this.parent.createElement('div');
        document.body.appendChild(div);
        this.dialogInstance = new DialogComponent(model);
        this.dialogInstance.createElement = this.parent.createElement;
        this.dialogInstance.appendTo(div);
        if (this.dialogInstance) {
            if (this.parent.enableRtl && this.dialogInstance.isModal) {
                this.dialogInstance.element.style.position = 'relative';
            }
            this.dialogInstance.refreshPosition();
        }
    }
    /**
     * To destroy the dialog if it open is prevented by user.
     *
     * @returns {void}
     */
    destroyDialog() {
        this.dialogInstance.destroy();
        remove(this.dialogInstance.element);
        this.dialogInstance = null;
    }
    /**
     * To hide dialog.
     *
     * @param {DialogModel} disableAnimation - To disable the animation while hiding the dialog.
     * @returns {void}
     */
    hide(disableAnimation) {
        if (this.dialogInstance) {
            if (disableAnimation) {
                this.dialogInstance.animationSettings.effect = 'None';
                this.dialogInstance.dataBind();
            }
            this.dialogInstance.hide();
        }
    }
    /**
     * To clear private variables.
     *
     * @returns {void}
     */
    destroy() {
        this.parent = null;
    }
}
